export default __webpack_public_path__ + "static/media/pescado.3842fa57.svg";